import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateNotificationsCount } from 'granite-admin/common/ducks/notificationsCount';
import { fetchNotificationCount, markRead, markAllRead } from 'granite-admin/common/gateways/notification-api';
function useNotificationsCount() {
  const dispatch = useDispatch();
  const notificationsCount = useSelector(({
    common
  }) => common.notificationsCount.notificationsCount);
  const handleFetchNotificationCount = useCallback(count => {
    if (count) {
      dispatch(updateNotificationsCount(count));
    } else {
      fetchNotificationCount().then(res => dispatch(updateNotificationsCount(res.count))).catch(err => console.log(err));
    }
  }, [dispatch]);
  const handleCountOnNotificationClick = async notificationPk => {
    await markRead(notificationPk);
    if (notificationsCount > 0) dispatch(updateNotificationsCount(notificationsCount - 1));
  };
  const handleMarkAllReadClick = async () => {
    try {
      await markAllRead();
      if (notificationsCount > 0) dispatch(updateNotificationsCount(0));
    } catch (e) {
      console.log('err', e);
    }
  };
  useEffect(() => {
    if (notificationsCount === '') {
      handleFetchNotificationCount();
    }
  }, [handleFetchNotificationCount, notificationsCount]);
  return {
    handleFetchNotificationCount,
    handleCountOnNotificationClick,
    handleMarkAllReadClick,
    notificationsCount
  };
}
export default useNotificationsCount;